"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FilterInputView = ({ filterFormDataItem, filterKey, onChange, type, name, }) => react_1.default.createElement("div", { className: `filter-box${filterFormDataItem.offerCount === 0 ? ' disabled' : ''}` },
    react_1.default.createElement("input", { id: `${filterFormDataItem.value}-input`, name: name, type: type, checked: filterFormDataItem.active, onChange: () => onChange(filterFormDataItem, filterKey) }),
    react_1.default.createElement("label", { htmlFor: `${filterFormDataItem.value}-input`, id: `${filterFormDataItem.value}-label` },
        filterFormDataItem.label,
        react_1.default.createElement("span", { className: "counter", translate: "no" },
            "(",
            filterFormDataItem.offerCount,
            ")")));
exports.default = FilterInputView;
